// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DebugController {
   $scope: any
   api: any
   constructor($scope: any, api: any) {
      this.apiUpdate = this.apiUpdate.bind(this)
      this.$scope = $scope
      this.api = api
      this.$scope.apiResponse = {}
      this.$scope.showResponse = false
      const prevRequest = (this.$scope.prevRequest = this.api.previousApiRequest)

      // wire up api update hook
      this.api.on('update', this.apiUpdate)

      // run the last request made
      if (prevRequest) { this.api.get(prevRequest.method, prevRequest.params, {debug: true}) }

      this.$scope.$on('$destroy', () => {
         return this.api.off('update', this.apiUpdate)
      })
   }

   apiUpdate(data: any, debug: any) {
      if (debug) { this.$scope.apiResponse = data }
      return this.$scope.showResponse = true
   }
}

DebugController.$inject = ['$scope', 'apiService']

angular.module('summonApp.controllers')
   .controller('DebugCtrl', DebugController)
